import React, {Component} from 'react';
import {Button, Grid, Header, Icon, Label, Segment,Divider} from 'semantic-ui-react';
import {APP_URL} from "../../constants/app_routes";

class ViewCompanyDetails extends Component {

    render() {
        const company = this.props.selectedObject[0];
        return (
            <div>
                <Header textAlign='center' size='large'>{company.name} : Company Details</Header>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Segment style={{height: '100%'}}>
                                <Label color='blue' ribbon>
                                    Company General Details
                                </Label>
                                <Grid.Column width={8}>
                                    <dl>
                                        <dt>Point of contact</dt>
                                        <dd>{company['point_of_contact']?company['point_of_contact']:"NA"}</dd>
                                        <dt>Email</dt>
                                        <dd>{company.email?company['email']:"NA"}</dd>
                                        <dt>Phone Number</dt>
                                        <dd>{company['phone_number']?company['phone_number']:"NA"}</dd>
                                        <dt>Invoice Email</dt>
                                        <dd style={{ overflowWrap: "anywhere" }}>{company['email_invoice']?company['email_invoice']:"NA"}</dd>
                                        <dt>Report Email</dt>
                                        <dd style={{ overflowWrap: "anywhere" }}>{company['email_report']?company['email_report']:"NA"}</dd>
                                    </dl>
                                </Grid.Column>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment style={{height: '100%'}}>
                            <Label color='blue' ribbon>
                               Company Address Details
                            </Label>
                            <Grid.Column width={8}>
                                <dl>
                                    <dt style={{minHeight: '75px'}}>Full Address</dt>
                                    <dd>{company.line1} , {company.line2},<br/>{company.locality},{company.city},<br/>{company.country},{company.postcode}
                                    </dd>
                                    <dt>Invoicing Frequency</dt>
                                    <dd className="format-capitalize">{company['invoice_frequency']}</dd>
                                </dl>
                                <div className="center-aligned">
                                    <Button className="format-bold" as='a' target="_blank" icon color='orange' size='mini' href={APP_URL+'/company/price_list/'+company['id']}><Icon
                                        name='dollar'/>View Company Price List</Button>
                                </div>
                            </Grid.Column>
                        </Segment>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <Segment>
                            <Label color='blue' ribbon>
                                    Company Requirements
                                </Label>
                                <dl>
                                    <dt>Booking Requirements</dt>
                                    <dd style={{ textAlign: "left" }} >{company['booking_requirements']?company['booking_requirements']:"None"}</dd>
                                    <Divider></Divider>
                                    <dt>Report Requirements</dt>
                                    <dd className="format-capitalize">{company['report_requirements']?company['report_requirements']:"None"}</dd>
                                    <Divider></Divider>
                                    <dt>Agent Booking Requirements</dt>
                                    <dd className="format-capitalize">{company['agent_booking_requirements']?company['agent_booking_requirements']:"None"}</dd>
                                    <Divider></Divider>
                                    <dt>24 Hour Turnaround</dt>
                                    <dd className="format-capitalize">{company['priority_tat']?"Yes":"No"}</dd>
                                </dl>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }

}

export default ViewCompanyDetails;


// WEBPACK FOOTER //
// ./src/views/company/view_company_details.js